module.exports = __webpack_public_path__ + "static/dmon-002-91b38c17f5ce2cb507ed953fec51d1f1.jpg";